/* Copyright (c) 2023 MOCA Systems, Inc.  All rights reserved. */

import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MaterialModule } from 'src/app/common/material/material-module';

@Component({
	standalone: true,
	imports: [MaterialModule],
	selector: 'password-policy-list',
	templateUrl: './password-policy-list.component.html',
	styleUrls: ['./password-policy-list.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PasswordPolicyListComponent {
	constructor() {}
}
